<template>
  <div v-if="!isLoginRoute">
    <!-- Botón flotante -->
    <button
      v-if="!showForm"
      @click="toggleForm"
      class="support-button btn"
      type="button"
    >
      <v-icon :icon="['fas', 'comments']" :style="{ color: 'white' }" />
    </button>

    <!-- Formulario de soporte -->
    <div v-if="showForm" class="support-form-container">
      <div class="support-form">
        <div class="support-header d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0">Soporte</h5>
          <button @click="toggleForm" class="btn-close" type="button"></button>
        </div>

        <div class="support-body">
          <div class="mb-3">
            <label for="supportType" class="form-label">Tipo de soporte</label>
            <select
              id="supportType"
              v-model="id_type_support"
              class="form-select"
              :disabled="loading || loadingSupportTypes"
            >
              <option value="" disabled>Seleccione un tipo de soporte</option>
              <option
                v-for="reason in supportReasons"
                :key="reason.id"
                :value="reason.id"
              >
                {{ reason.name }}
              </option>
            </select>
          </div>

          <div class="mb-3">
            <label for="supportDescription" class="form-label">Descripción</label>
            <textarea
              id="supportDescription"
              v-model="description"
              class="form-control"
              rows="5"
              placeholder="Describe tu consulta o problema..."
              :disabled="loading"
            ></textarea>
          </div>

          <div v-if="message" :class="['alert', messageType === 'success' ? 'alert-success' : 'alert-danger']">
            {{ message }}
          </div>

          <div class="d-flex justify-content-end gap-2">
            <button
              @click="toggleForm"
              class="btn btn-secondary"
              type="button"
              :disabled="loading"
            >
              Cancelar
            </button>
            <button
              @click="submitSupport"
              class="btn btn-primary"
              type="button"
              :disabled="loading || !description.trim() || !id_type_support"
            >
              <span v-if="loading">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Enviando...
              </span>
              <span v-else>
                <v-icon :icon="['fas', 'paper-plane']" class="me-2" />
                Enviar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Cookies from "js-cookie";
import Swal from "sweetalert2";

export default {
  name: "SupportButton",
  data() {
    return {
      showForm: false,
      description: "",
      loading: false,
      message: "",
      messageType: "",
      supportReasons: [],
      id_type_support: "",
      loadingSupportTypes: false
    };
  },
  computed: {
    isLoginRoute() {
      const route = this.$route;
      if (!route) return false;

      const name = (route.name || "").toString().toLowerCase();
      const path = (route.path || "").toString().toLowerCase();

      return name === "login" || path === "/login";
    }
  },
  mounted() {
    this.loadSupportReasons();
  },
  methods: {
    ...mapActions(["getData", "createData"]),

    toggleForm() {
      this.showForm = !this.showForm;
      if (!this.showForm) {
        // Limpiar el formulario al cerrar
        this.description = "";
        this.message = "";
        this.messageType = "";
        this.id_type_support = "";
      }
    },

    async submitSupport() {
      if (!this.description.trim() || !this.id_type_support) {
        return;
      }

      this.loading = true;
      this.message = "";
      this.messageType = "";

      const data = {
        id_user: Cookies.get("id"),
        id_type_support: this.id_type_support,
        description: this.description.trim(),
        origin: "CAMPUS"
      };

      try {
        const response = await this.createData({
          url: "support_form/dash/save",
          data: data
        });

        if (response && response.code === 200) {
          this.description = "";
          this.id_type_support = "";

          Swal.fire({
            title: "¡Tu solicitud fue enviada!",
            text: "Gracias por escribirnos. Tu mensaje de soporte ha sido enviado correctamente y lo revisaremos a la brevedad.",
            icon: "success",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#003068"
          }).then(() => {
            this.toggleForm();
          });
        } else {
          this.message = response?.message || "Error al enviar la solicitud";
          this.messageType = "error";
        }
      } catch (error) {
        console.error("Error al enviar soporte:", error);
        this.message = "Error al enviar la solicitud. Intenta nuevamente.";
        this.messageType = "error";
      } finally {
        this.loading = false;
      }
    },

    loadSupportReasons() {
      this.supportReasons = [
        { id: 1, name: "Soporte Técnico" },
        { id: 2, name: "Consulta de Pago" },
        { id: 3, name: "Información de Cursos" },
        { id: 4, name: "Certificados y Constancias" },
        { id: 5, name: "Cambio de Datos" },
        { id: 6, name: "Reclamo" },
        { id: 7, name: "Sugerencia" },
        { id: 8, name: "Convenios y Alianzas" },
        { id: 9, name: "Prensa y Medios" },
        { id: 10, name: "Otro" }
      ];
    }
  }
};
</script>

<style scoped>
.support-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  transition: all 0.3s ease;
  border: none;
  background: rgb(53, 16, 32);
}

.support-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.support-form-container {
  position: fixed;
  bottom: 100px;
  right: 30px;
  z-index: 1000;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.support-form {
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  padding: 20px;
  width: 350px;
  max-width: 90vw;
}

.support-header {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
}

.support-header h5 {
  color: #003068;
  font-weight: 600;
}

.support-body {
  padding-top: 15px;
}

.btn-close {
  background: transparent;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.2s;
}

.btn-close:hover {
  opacity: 1;
}

.gap-2 {
  gap: 0.5rem;
}

@media (max-width: 576px) {
  .support-button {
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
  }

  .support-form-container {
    bottom: 80px;
    right: 20px;
    left: 20px;
  }

  .support-form {
    width: 100%;
  }
}
</style>
